import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL, FRONTEND_URL } from "../../../config/axios";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import {
    customSortByKey,
    generateCustomKey,
    handleAllError,
    handleErrorToast,
    normalizeEmployeeStatus,
} from "../../CustomFunctions";
import { DropdownArrow, DropdownArrowOption, UpdatePencil } from "../../AllSvg";
import usePermission from "../../../config/permissions";
import {
    StartEmployeeSeprationProcess,
    ViewSeprationAndSettlementDetails,
    ViewSeprationAndSettlementProcessStatus,
    ViewSeprationDetails,
    ViewSeprationProcessStatus,
} from "../../SeprationManagement/SeprationComponents";
import { ViewLetterBuilder } from "../../DynamicBuilders/LetterBuilderManagement/LetterTemplateComponentsTesting";
import { formatDate, formattedDateLong } from "../../Date";

const AddNewEmployeeData = ({ getAllEmployee, SubCompany, SUPER_ADMIN }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        getDepartment();
        getDesignation();
        getAttendpolicy();
        getWeeklypolicy();
        getReportingHeads();
        getWorksiteList();
        setShow(true);
    };

    const [formData, setFormData] = useState({
        emp_code: "",
        machine_code: "",
        user_detail: "",
        department: "",
        designation: "",
        is_reporthead: "",
        leavebalance: "0",
        casual_leave: "0",
        sick_leave: "0",
        earn_leave: "0",
        employee_type: "",
        joining_date: "",
        location: "",
        division: sessionStorage.getItem("company_id") || "",
        attendance_policy: "",
        weeklyoff_policy: "",
        employee_status: "active",
        role: "",
        cost_center_assets: "employee",
        show_attendance: true,
        show_herarchy: true,
        url: FRONTEND_URL,
    });

    // ?  ************** Data Fetch start **************  ? //
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [buffer3, setBuffering3] = useState(true);
    const [buffer4, setBuffering4] = useState(true);
    const [buffer5, setBuffering5] = useState(true);
    const [buffer6, setBuffering6] = useState(true);

    const [departmentname, setDepartmentname] = useState([]);
    const [designationname, setDesignationname] = useState([]);
    const [attendpolicy, setAttendpolicy] = useState([]);
    const [weeklypolicy, setWeeklypolicy] = useState([]);
    const [rhname, setRhname] = useState([]);
    const [worksite, setWorksite] = useState([]);

    const getDepartment = async () => {
        try {
            setBuffering1(true);
            // const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            const dep = await axios.get(
                `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${formData.division || "null"}/active/`,
            );
            setDepartmentname(dep.data);
        } catch (err) {
        } finally {
            setBuffering1(false);
        }
    };

    const getDesignation = async () => {
        try {
            setBuffering2(true);
            // const des = await axios.get(`${BASE_URL}/wfm/designationfilterbysubcompanycount/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            const des = await axios.get(
                `${BASE_URL}/wfm/designationfilterbysubcompanycount/${formData.division || "null"}/active/`,
            );
            setDesignationname(des.data);
        } catch (err) {
        } finally {
            setBuffering2(false);
        }
    };

    const getAttendpolicy = async () => {
        try {
            setBuffering3(true);
            // const att = await axios.get(`${BASE_URL}/wfm/attendancepolicyfilterall/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            const att = await axios.get(
                `${BASE_URL}/wfm/attendancepolicyfilterall/${formData.division || "null"}/active/`,
            );
            setAttendpolicy(att.data);
        } catch (err) {
        } finally {
            setBuffering3(false);
        }
    };

    const getWeeklypolicy = async () => {
        try {
            setBuffering4(true);
            // const week = await axios.get(`${BASE_URL}/wfm/weeklyoffpolicyfilterall/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            const week = await axios.get(
                `${BASE_URL}/wfm/weeklyofffilterbysubcompanycount/${formData.division || "null"}/active/`,
            );
            setWeeklypolicy(week.data);
        } catch (err) {
        } finally {
            setBuffering4(false);
        }
    };

    const getWorksiteList = async () => {
        try {
            setBuffering5(true);
            // const res = await axios.get(`${BASE_URL}/wfm/worksitefilterbysubcompanycount/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            const res = await axios.get(
                `${BASE_URL}/wfm/worksitefilterbysubcompanycount/${formData.division || "null"}/active/`,
            );
            setWorksite(res.data);
        } catch (err) {
        } finally {
            setBuffering5(false);
        }
    };

    const getReportingHeads = async () => {
        try {
            setBuffering6(true);
            // const res = await axios.get(`${BASE_URL}/wfm/rhlistactive/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            // const res = await axios.get(`${BASE_URL}/wfm/rhlistactive/${formData.division || 'null'}/active/`);
            const res = await axios.get(
                `${BASE_URL}/wfm/rhlistactive/${formData.division}/active/`,
            );
            setRhname(res.data);
        } catch (err) {
        } finally {
            setBuffering6(false);
        }
    };

    useEffect(() => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            department: "",
            designation: "",
            attendance_policy: "",
            weeklyoff_policy: "",
            location: "",
            reporting_head: "",
        }));
        getDepartment();
        getDesignation();
        getAttendpolicy();
        getWeeklypolicy();
        // getReportingHeads();
        getWorksiteList();
    }, [formData?.division]);

    // !  ************** Data Fetch end **************  ! //

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "name",
            "email",
            "emp_code",
            "machine_code",
            "department",
            "designation",
            "reporting_head",
            "is_reporthead",
            "employee_type",
            "joining_date",
            "location",
            "division",
            "attendance_policy",
            "weeklyoff_policy",
            "role",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });
        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        let { name, value } = e.target;

        // --- ADDED VALIDATION FOR EMP_CODE ---
        if (name === "emp_code") {
            // This regex removes any character that is NOT a letter (a-z, A-Z), 
            // a number (0-9), a hyphen (-), or an underscore (_)
            value = value.replace(/[^a-zA-Z0-9_-]/g, "");
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        setFormData({
            ...formData,
            [name]: value,
        });
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: checked,
        }));
    };

    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic

    const executeSubmit = async () => {
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        const newPassword = generateCustomKey("Aimantra");

        const updatedFormData = {
            ...formData,
            user_detail: formData.email,
            employee: formData.email,
            email: formData.email,
            password: newPassword,
        };

        try {
            let res = await axios.post(
                `${BASE_URL}/wfm/ourcompanyuserdetaildirectadd/`,
                updatedFormData,
            );
            if (res.status === 200) {
                handleClose();
                await getAllEmployee();
            }
        } catch (err) {
            handleAllError(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            // Create the customized JSX message with bolded critical fields
            // Create the customized JSX message with requested layout
            const confirmationMessage = (
                <div style={{ padding: "0 15px" }}> {/* Added horizontal padding */}

                    {/* Title */}
                    <h6 style={{
                        marginTop: "0",
                        marginBottom: "15px",
                        color: "#333",
                        fontSize: "20px",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        textAlign: "center"
                    }}>
                        Please review the critical details before confirming:
                    </h6>

                    {/* Divider */}
                    <hr className="line" />

                    {/* Details Container - Left aligned to match your screenshot */}
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        fontSize: "15px",
                        color: "#555",
                        textAlign: "left"
                    }}>
                        {/* Row 1: Name and Emp Code inline */}
                        <div style={{ display: "flex", gap: "30px" }}>
                            <span>Name: <strong style={{ color: "#333" }}>{formData.name}</strong></span>
                            <span>Emp Code: <strong style={{ color: "#333" }}>{formData.emp_code}</strong></span>
                        </div>
                        {/* Row 2: Email */}
                        <div>
                            <span>Email: <strong style={{ color: "#333" }}>{formData.email}</strong></span>
                        </div>
                    </div>

                    <hr className="line" />
                </div>
            );

            // Fire the toast and pass the actual submission logic as the onYes callback
            confirmToast(confirmationMessage, executeSubmit);
        }
    };

    // const handleFormSubmit = async (e) => {
    //     e.preventDefault();

    //     if (validateForm()) {
    //         setLoading(true); //loading logic

    //         const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    //         const newPassword = generateCustomKey("Aimantra");

    //         const updatedFormData = {
    //             ...formData,
    //             user_detail: formData.email,
    //             employee: formData.email,
    //             email: formData.email,
    //             password: newPassword,
    //             // role: "Employee",
    //         };

    //         try {
    //             let res = await axios.post(
    //                 `${BASE_URL}/wfm/ourcompanyuserdetaildirectadd/`,
    //                 updatedFormData,
    //             );
    //             if (res.status === 200) {
    //                 handleClose();
    //                 await getAllEmployee();
    //             }
    //         } catch (err) {
    //             //toast Logic
    //             handleAllError(err, loadingToastId);
    //         } finally {
    //             setLoading(false); //loading logic
    //             toast.dismiss(loadingToastId);
    //         }
    //     }
    // };

    return (
        <>
            <button
                title="Add New Employee"
                className="models-button model-add"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    enable-background="new 0 0 24 24"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    id="hiring"
                >
                    <g id="Layer_2">
                        <path
                            fill="#2576BC"
                            d="M18,16c-0.5522,0-1,0.4473-1,1v1h-1c-0.5522,0-1,0.4473-1,1s0.4478,1,1,1h1v1c0,0.5527,0.4478,1,1,1s1-0.4473,1-1v-1h1 c0.5522,0,1-0.4473,1-1s-0.4478-1-1-1h-1v-1C19,16.4473,18.5522,16,18,16z"
                        ></path>
                        <path
                            fill="#2576BC"
                            d="M5.2554 15.4678l-.54 1.8887c-.249.8701-.0791 1.7832.4658 2.5059S6.5581 21 7.4634 21H13c.5522 0 1-.4473 1-1s-.4478-1-1-1H7.4634c-.272 0-.5215-.124-.6851-.3418-.1636-.2168-.2148-.4902-.1401-.752l.54-1.8896C7.5176 14.8291 8.6167 14 9.8516 14h4.2969c.7061 0 1.3799.2656 1.897.7471.4028.376 1.0366.3555 1.4131-.0498.3765-.4033.3545-1.0361-.0498-1.4131C16.5205 12.4561 15.3628 12 14.1484 12H9.8516C7.728 12 5.8379 13.4258 5.2554 15.4678zM16 7c0-2.2061-1.7944-4-4-4S8 4.7939 8 7s1.7944 4 4 4S16 9.2061 16 7zM10 7c0-1.1025.897-2 2-2s2 .8975 2 2-.897 2-2 2S10 8.1025 10 7z"
                        ></path>
                    </g>
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title>New Employee Onboarding</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <form className="register-form">
                            <div className="form-flex-wrap">
                                <div title="Name" className="flex-column">
                                    <label
                                        htmlFor="name"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Candidate name"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.name ? "error" : inputState.name ? "success" : ""
                                            }`}
                                    />
                                    {errors.name && (
                                        <span className="error-message font-size-text ">
                                            {errors.name}
                                        </span>
                                    )}
                                </div>

                                <div title="Email" className="flex-column">
                                    <label
                                        htmlFor="email"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Email<span className="required">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Demo@gmail.com"
                                        onChange={handleInputChange}
                                        value={formData.email}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.toLowerCase().trim(); // Convert input to lowercase
                                        }}
                                        className={`form-input ${errors.email ? "error" : inputState.email ? "success" : ""
                                            }`}
                                    />
                                    {errors.email && (
                                        <span className="error-message font-size-text ">
                                            {errors.email}
                                        </span>
                                    )}
                                </div>

                                <div title="Emp Code" className="flex-column">
                                    <label
                                        htmlFor="emp_code"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Emp Code<span className="required">*</span>
                                        &nbsp;
                                        <span className="required">(Only alphabets, numbers, - , _ are allowed)</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="emp_code"
                                        name="emp_code"
                                        placeholder="Emp Code"
                                        onChange={handleInputChange}
                                        value={formData.emp_code}
                                        pattern="[a-zA-Z0-9_-]+"
                                        title="Only alphabets, numbers, hyphens (-) and underscores (_) are allowed"
                                        className={`form-input ${errors.emp_code
                                            ? "error"
                                            : inputState.emp_code
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emp_code && (
                                        <span className="error-message font-size-text ">
                                            {errors.emp_code}
                                        </span>
                                    )}
                                </div>

                                <div title="Machine Code" className="flex-column">
                                    <label
                                        htmlFor="machine_code"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Machine Code<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="machine_code"
                                        name="machine_code"
                                        placeholder="Machine Code"
                                        onChange={handleInputChange}
                                        value={formData.machine_code}
                                        className={`form-input ${errors.machine_code
                                            ? "error"
                                            : inputState.machine_code
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.machine_code && (
                                        <span className="error-message font-size-text ">
                                            {errors.machine_code}
                                        </span>
                                    )}
                                </div>

                                <div title="Joining Date" className="flex-column">
                                    <label
                                        htmlFor="joining_date"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Joining Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="joining_date"
                                        name="joining_date"
                                        onChange={handleInputChange}
                                        value={formData.joining_date}
                                        className={`form-input ${errors.joining_date
                                            ? "error"
                                            : inputState.joining_date
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.joining_date && (
                                        <span className="error-message font-size-text ">
                                            {errors.joining_date}
                                        </span>
                                    )}
                                </div>

                                {SUPER_ADMIN && (
                                    <div title="Sub Company List" className="flex-column ">
                                        <label
                                            htmlFor="division"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Division<span className="required">*</span>
                                        </label>

                                        <select
                                            id="division"
                                            name="division"
                                            value={formData.division}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.division
                                                ? "error"
                                                : inputState.division
                                                    ? "success"
                                                    : ""
                                                }`}
                                        >
                                            <option value="">Select a Division</option>
                                            {SubCompany?.sort((a, b) =>
                                                a.title.localeCompare(b.title, "en", {
                                                    ignorePunctuation: true,
                                                }),
                                            ).map((i, index) => (
                                                <>
                                                    <option value={i.id}>{i.title}</option>
                                                </>
                                            ))}
                                        </select>

                                        <div>
                                            {errors.division && (
                                                <span className="error-message font-size-text ">
                                                    {errors.division}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div title="Departments List" className="flex-column ">
                                    <label
                                        htmlFor="department"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Department<span className="required">*</span>
                                    </label>

                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="department"
                                                name="department"
                                                value={formData.department}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.department
                                                    ? "error"
                                                    : inputState.department
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select Department</option>
                                                {departmentname
                                                    ?.sort((a, b) =>
                                                        a.title.localeCompare(b.title, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.id}>
                                                                {i.title}-{i.sub_company_name}
                                                            </option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.department && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.department}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="Designations List" className="flex-column ">
                                    <label
                                        htmlFor="designation"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Designation<span className="required">*</span>
                                    </label>

                                    {buffer2 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="designation"
                                                name="designation"
                                                value={formData.designation}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.designation
                                                    ? "error"
                                                    : inputState.designation
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select Designation</option>
                                                {designationname
                                                    ?.sort((a, b) =>
                                                        a.title.localeCompare(b.title, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.id}>
                                                                {i.title}-{i.sub_company_name}
                                                            </option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.designation && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.designation}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="Attendance Policy List" className="flex-column ">
                                    <label
                                        htmlFor="attendance_policy"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Attendance Policy<span className="required">*</span>
                                    </label>

                                    {buffer3 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="attendance_policy"
                                                name="attendance_policy"
                                                value={formData.attendance_policy}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.attendance_policy
                                                    ? "error"
                                                    : inputState.attendance_policy
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Attendance Policy</option>
                                                {attendpolicy
                                                    ?.sort((a, b) =>
                                                        a.name.localeCompare(b.name, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.id}>
                                                                {i.name}-{i.sub_company_title}
                                                            </option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.attendance_policy && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.attendance_policy}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="WeeklyOff Policy List" className="flex-column ">
                                    <label
                                        htmlFor="weeklyoff_policy"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        WeeklyOff Policy<span className="required">*</span>
                                    </label>

                                    {buffer4 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="weeklyoff_policy"
                                                name="weeklyoff_policy"
                                                value={formData.weeklyoff_policy}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.weeklyoff_policy
                                                    ? "error"
                                                    : inputState.weeklyoff_policy
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Weeklyoff Policy</option>
                                                {weeklypolicy
                                                    ?.sort((a, b) =>
                                                        a.name.localeCompare(b.name, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.id}>
                                                                {i.name}-{i.sub_company_name}
                                                            </option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.weeklyoff_policy && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.weeklyoff_policy}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="Work Location List" className="flex-column ">
                                    <label
                                        htmlFor="location"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Work Site<span className="required">*</span>
                                    </label>

                                    {buffer5 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="location"
                                                name="location"
                                                value={formData.location}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.location
                                                    ? "error"
                                                    : inputState.location
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a location</option>
                                                {worksite
                                                    ?.sort((a, b) =>
                                                        a.title.localeCompare(b.title, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.id}>
                                                                {i.title}-{i.sub_company_name}
                                                            </option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.location && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.location}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="Reporting Heads List" className="flex-column ">
                                    <label
                                        htmlFor="reporting_head"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Reporting Head<span className="required">*</span>
                                    </label>

                                    {buffer6 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="reporting_head"
                                                name="reporting_head"
                                                value={formData.reporting_head}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.reporting_head
                                                    ? "error"
                                                    : inputState.reporting_head
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Reporting Head</option>
                                                {rhname
                                                    ?.sort((a, b) =>
                                                        a.name.localeCompare(b.name, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.user_detail}>
                                                                {i.name}-{i.division_name}
                                                            </option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.reporting_head && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.reporting_head}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="Is Reporting Head" className="flex-column ">
                                    <label
                                        htmlFor="is_reporthead"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Is Reporting Head<span className="required">*</span>
                                    </label>

                                    <select
                                        id="is_reporthead"
                                        name="is_reporthead"
                                        value={formData.is_reporthead}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.is_reporthead
                                            ? "error"
                                            : inputState.is_reporthead
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select Option</option>
                                        <option value="True">Yes</option>
                                        <option value="False">No</option>
                                    </select>

                                    <div>
                                        {errors.is_reporthead && (
                                            <span className="error-message font-size-text ">
                                                {errors.is_reporthead}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div title="Dashboard Employee Roles" className="flex-column ">
                                    <label
                                        htmlFor="employee_type"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Employee Role<span className="required">*</span>
                                    </label>

                                    <select
                                        id="role"
                                        name="role"
                                        value={formData.role}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.role ? "error" : inputState.role ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select a Role</option>
                                        <option value="Employee">Employee</option>
                                        <option value="ReportingHead">Team Lead</option>
                                        <option value="HOD">HOD</option>
                                        <option value="Career">Career</option>
                                        <option value="HR">HR</option>
                                        <option value="Admin">Admin</option>
                                        <option value="IT">IT</option>
                                        <option value="Account">Accounts</option>
                                        <option value="SiteManagement">Site Management</option>
                                    </select>

                                    <div>
                                        {errors.role && (
                                            <span className="error-message font-size-text ">
                                                {errors.role}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div title="Employee Type" className="flex-column ">
                                    <label
                                        htmlFor="employee_type"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Employee Type<span className="required">*</span>
                                    </label>

                                    <select
                                        id="employee_type"
                                        name="employee_type"
                                        value={formData.employee_type}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.employee_type
                                            ? "error"
                                            : inputState.employee_type
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Employee</option>
                                        <option value="permanent">Permanent</option>
                                        <option value="temporary">Temporary</option>
                                        <option value="probation">Probation</option>
                                        <option value="termination">Termination</option>
                                        <option value="resigned">Resigned</option>
                                        <option value="absconding">Absconding</option>
                                        <option value="healthissue">Health Issue</option>
                                        <option value="intern">Intern</option>
                                        <option value="trainee">Trainee</option>
                                        <option value="transferred">Transferred</option>
                                    </select>

                                    <div>
                                        {errors.employee_type && (
                                            <span className="error-message font-size-text ">
                                                {errors.employee_type}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* <div title="Employeee Cost-Center Assets" className="flex-column ">
                                    <label htmlFor="cost_center_assets" className="form-labels font-weight500 font-size-subheading">
                                        Cost Center Assets<span className="required">*</span>
                                    </label>
                                    
                                    <select
                                        id="cost_center_assets"
                                        name="cost_center_assets"
                                        value={formData.cost_center_assets}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.cost_center_assets ? "error" : inputState.cost_center_assets ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select a Cost Center Assets</option>
                                        <option value="employee">Employee</option>
                                        <option value="currentasset">Current Asset</option>
                                        <option value="fixedasset">Fixed Asset</option>
                                    </select>
                                
                                    <div>
                                        {errors.cost_center_assets && (
                                            <span className="error-message font-size-text ">{errors.cost_center_assets}</span>
                                        )}
                                    </div>
                                </div> */}
                            </div>
                            <div className="flex-row justify-evenly">
                                <div className="flex-row ">
                                    <div className="checkbox-toggle">
                                        <input
                                            type="checkbox"
                                            id="toggle_show_herarchy"
                                            name="show_herarchy"
                                            checked={formData.show_herarchy}
                                            onChange={handleCheckboxChange}
                                        />
                                        <label htmlFor="toggle_show_herarchy"></label>
                                    </div>
                                    <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
                                    <label
                                        htmlFor="EmpCode"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        {formData.show_herarchy ? "View" : "Hide"} in Hierarchy{" "}
                                    </label>
                                </div>

                                <div className="flex-row ">
                                    <div className="checkbox-toggle">
                                        <input
                                            type="checkbox"
                                            id="toggle_show_attendance"
                                            name="show_attendance"
                                            checked={formData.show_attendance}
                                            onChange={handleCheckboxChange}
                                        />
                                        <label htmlFor="toggle_show_attendance"></label>
                                    </div>
                                    <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
                                    <label
                                        htmlFor="EmpCode"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        {formData.show_attendance ? "View" : "Hide"} Attendance{" "}
                                    </label>
                                </div>
                            </div>

                            <div className="button-models">
                                <button
                                    onClick={handleFormSubmit}
                                    className="model-button font-weight500 model-button-submit"
                                    disabled={loading}
                                >
                                    {/* //loading logic */}
                                    Submit
                                </button>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted &&
                                    Object.keys(errors).length > 0 &&
                                    (Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">
                                            Please fill all mandatory fields!
                                        </h5>
                                    ) : (
                                        <h6 className="text-center">
                                            {Object.keys(errors)
                                                .map((field) =>
                                                    field
                                                        .replace(/_/g, " ")
                                                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                                                )
                                                .join(", ") + " are required!"}
                                        </h6>
                                    ))}
                            </p>
                        </form>
                    </>
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

const confirmToast = (message, onYes) => {
    const toastId = "confirm-toast";

    if (toast.isActive(toastId)) return;

    toast.info(
        ({ closeToast }) => (
            <div style={{ textAlign: "center", padding: "4px" }}>
                <div style={{ marginBottom: "15px" }}>{message}</div>

                <div style={{ display: "flex", gap: "12px", justifyContent: "center", marginTop: "15px" }}>
                    <button
                        className="model-button model-button-cancel font-weight500"
                        onClick={() => {
                            toast.dismiss(toastId);
                        }}
                    >
                        Cancel
                    </button>

                    <button
                        className={`model-button font-weight500 font-size-heading model-button-leave`}
                        onClick={() => {
                            toast.dismiss(toastId);
                            onYes();
                        }}
                    >
                        Confirm & Save
                    </button>
                </div>
            </div>
        ),
        {
            toastId,
            autoClose: false,
            closeOnClick: false,
            draggable: false,
            closeButton: false,
            // --- Increased width to 600px to fit everything on one line ---
            style: { width: "600px", maxWidth: "95vw" }
        }
    );
};

const UpdateEmployeeData = ({
    i,
    email,
    getAllEmployee,
    SubCompany,
    SUPER_ADMIN,
    btn_title,
}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = async () => {
        setShow(true);
        const empData = await getEmployeeOrgData(i.emp_code);

        // Fallback to sessionStorage just in case it's missing
        const empDivision = empData?.division || sessionStorage.getItem("company_id");

        getDepartment(empDivision);
        getDesignation(empDivision);
        getAttendpolicy(empDivision);
        getWeeklypolicy(empDivision);
        getReportingHeads(empDivision);
        getWorksiteList(empDivision);
        getLetterTemplates(empDivision);

        // getEmployeeOrgData(i.emp_code);
        // getDepartment();
        // getDesignation();
        // getAttendpolicy();
        // getWeeklypolicy();
        // getReportingHeads();
        // getWorksiteList();
        // getLetterTemplates();
        // getTaxRegime();
        // setShow(true);
    };

    const [formData, setFormData] = useState({
        emp_code: "",
        machine_code: "",
        user_detail: email || "",
        department: "",
        designation: "",
        // is_reporthead: "false",
        leavebalance: "0",
        casual_leave: "0",
        sick_leave: "0",
        earn_leave: "0",
        employee_type: "",
        joining_date: "",
        location: "",
        division: sessionStorage.getItem("company_id") || "",
        attendance_policy: "",
        weeklyoff_policy: "",
        cost_center_assets: "",
        show_attendance: true,
        show_herarchy: true,
        employee_status: "active",
        role: "",
        url: FRONTEND_URL,
        last_working_date: "",
        prevcompany_last_working_date: ""
    });

    const [initialStatus, setInitialStatus] = useState("");

    // ?  ************** Data Fetch start **************  ? //
    const [buffer, setBuffering] = useState(false);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [buffer3, setBuffering3] = useState(true);
    const [buffer4, setBuffering4] = useState(true);
    const [buffer5, setBuffering5] = useState(true);
    const [buffer6, setBuffering6] = useState(true);
    const [buffer7, setBuffering7] = useState(true);
    const [buffer8, setBuffering8] = useState(true);
    const [divisionChangeNoticeError, setDivisionChangeNotice] = useState("");
    const [DivisionChangeConfirmation, setDivisionChangeConfirmation] =
        useState(false);

    // const [employeeOrgDetails, setEmployeeOrgDetails] = useState([]);
    const [departmentname, setDepartmentname] = useState([]);
    const [designationname, setDesignationname] = useState([]);
    const [attendpolicy, setAttendpolicy] = useState([]);
    const [weeklypolicy, setWeeklypolicy] = useState([]);
    const [rhname, setRhname] = useState([]);
    const [worksite, setWorksite] = useState([]);
    const [lettersTemplate, setLettersTemplateData] = useState([]);
    // const [taxRegimes, setTaxRegimes] = useState([]);

    // const getEmployeeOrgData = async (emp_code) => {
    //     try {
    //         setBuffering(true);
    //         const emp = await axios.get(
    //             `${BASE_URL}/wfm/ourcompanydetailsbyemp/${emp_code}/`,
    //         );
    //         setInitialStatus(emp.data.employee_status);
    //         // setEmployeeOrgDetails(emp.data);
    //         setFormData(emp.data);
    //         return emp.data;
    //     } catch (err) {
    //         //toast Logic
    //         handleAllError(err);
    //     } finally {
    //         setBuffering(false);
    //     }
    // };
    const getEmployeeOrgData = async (emp_code) => {
        try {
            setBuffering(true);
            const emp = await axios.get(
                `${BASE_URL}/wfm/ourcompanydetailsbyemp/${emp_code}/`,
            );
            const employeeData = emp.data || {};
            const normalizedStatus = normalizeEmployeeStatus(employeeData.employee_status);
            setInitialStatus(normalizedStatus);
            setFormData({
                ...employeeData,
                employee_status: normalizedStatus,
                last_working_date: employeeData.last_working_date || "",
            });
            return employeeData;
        } catch (err) {
            //toast Logic
            handleAllError(err);
        } finally {
            setBuffering(false);
        }
    };

    const getDepartment = async (div) => {
        try {
            setBuffering1(true);
            // const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            const dep = await axios.get(
                `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${div ? div : formData.division || "null"}/active/`,
            );
            setDepartmentname(dep.data);
        } catch (err) {
        } finally {
            setBuffering1(false);
        }
    };

    const getDesignation = async (div) => {
        try {
            setBuffering2(true);
            // const des = await axios.get(`${BASE_URL}/wfm/designationfilterbysubcompanycount/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            const des = await axios.get(
                `${BASE_URL}/wfm/designationfilterbysubcompanycount/${div ? div : formData.division || "null"}/active/`,
            );
            setDesignationname(des.data);
        } catch (err) {
        } finally {
            setBuffering2(false);
        }
    };

    const getAttendpolicy = async (div) => {
        try {
            setBuffering3(true);
            // const att = await axios.get(`${BASE_URL}/wfm/attendancepolicyfilterall/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            const att = await axios.get(
                `${BASE_URL}/wfm/attendancepolicyfilterall/${div ? div : formData.division || "null"}/active/`,
            );
            setAttendpolicy(att.data);
        } catch (err) {
        } finally {
            setBuffering3(false);
        }
    };

    const getWeeklypolicy = async (div) => {
        try {
            setBuffering4(true);
            // const week = await axios.get(`${BASE_URL}/wfm/weeklyoffpolicyfilterall/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            const week = await axios.get(
                `${BASE_URL}/wfm/weeklyoffpolicyfilterall/${div ? div : formData.division || "null"}/active/`,
            );
            setWeeklypolicy(week.data);
        } catch (err) {
        } finally {
            setBuffering4(false);
        }
    };

    const getWorksiteList = async (div) => {
        try {
            setBuffering5(true);
            // const res = await axios.get(`${BASE_URL}/wfm/worksitefilterbysubcompanycount/${formData.division || sessionStorage.getItem('company_id')}/active/`);
            const res = await axios.get(
                `${BASE_URL}/wfm/worksitefilterbysubcompanycount/${div ? div : formData.division || "null"}/active/`,
            );
            setWorksite(res.data);
        } catch (err) {
        } finally {
            setBuffering5(false);
        }
    };

    const getReportingHeads = async (div) => {
        try {
            setBuffering6(true);
            const res = await axios.get(
                `${BASE_URL}/wfm/rhlistactive/${div ? div : formData.division || "null"}/active/`,
            );
            setRhname(res.data);
        } catch (err) {
        } finally {
            setBuffering6(false);
        }
    };

    const getLetterTemplates = async (div) => {
        setBuffering7(true);
        try {
            const template = await axios.get(
                `${BASE_URL}/wfm/letter-builder-template-bysubcompany/${div ? div : formData.division || "null"}/`,
            );
            setLettersTemplateData(template.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering7(false);
        }
    };

    // const getTaxRegime = async (div) => {
    //     setBuffering8(true);
    //     try {
    //         const fetchTaxRegime = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${div ? div : formData.division || 'null'}/`);
    //         setTaxRegimes(fetchTaxRegime.data);
    //     } catch (error) {
    //         handleErrorToast(error);
    //     } finally {
    //         setBuffering8(false);
    //     }
    // }

    // !  ************** Data Fetch end **************  ! //

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const isChangingToActive = initialStatus === "inactive" && formData.employee_status === "active";
    const isCurrentlyInactive = formData.employee_status === "inactive";

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            // "email",
            "emp_code",
            "machine_code",
            "department",
            "designation",
            // "leavebalance",
            // "casual_leave",
            // "sick_leave",
            // "earn_leave",
            "reporting_head",
            "is_reporthead",
            "employee_type",
            "joining_date",
            "location",
            "division",
            "attendance_policy",
            "weeklyoff_policy",
            "role",

            isCurrentlyInactive ? "last_working_date" : null,
            isChangingToActive ? "prevcompany_last_working_date" : null,

        ].filter(Boolean);
        requiredFields.forEach((field) => {
            // if (!formData[field]) {
            //     newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
            //         } is required !`;
            // }
            // Special handling for boolean fields
            if (field === "is_reporthead") {
                // Check if it's undefined or null (but allow false as a valid value)
                if (formData[field] === undefined || formData[field] === null) {
                    newErrors[field] =
                        ` ${field.charAt(0).toUpperCase() + field.slice(1).replace("_", " ")} is required !`;
                }
            } else {
                // For non-boolean fields, check if empty
                if (!formData[field] && formData[field] !== 0) {
                    newErrors[field] =
                        ` ${field.charAt(0).toUpperCase() + field.slice(1).replace("_", " ")} is required !`;
                }
            }
        });
        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        if (name === "division") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
                department: "",
                designation: "",
                attendance_policy: "",
                weeklyoff_policy: "",
                location: "",
                reporting_head: "",
            }));
            getDepartment(value);
            getDesignation(value);
            getAttendpolicy(value);
            getWeeklypolicy(value);
            getReportingHeads(value);
            getWorksiteList(value);
            getLetterTemplates(value);
            // getTaxRegime(value);
        } else if (name === "is_reporthead") {
            setFormData((prev) => ({
                ...prev,
                [name]: value === "true",
            }));
        }
        // else if (name === "is_reporthead") {
        //     setFormData({
        //         ...formData,
        //         [name]: value === "true"
        //     });
        // }
        // else {
        //     setFormData({
        //         ...formData,
        //         [name]: value,
        //     });
        // }
        else if (name === "employee_status") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
                last_working_date: "",
                prevcompany_last_working_date: "",
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: checked,
        }));
    };

    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic

    // const handleFormSubmit = async (e) => {
    //     e.preventDefault();
    //     const updatedformData = {
    //         ...formData,
    //         employee_status: normalizeEmployeeStatus(formData.employee_status),
    //         updated_by: sessionStorage.getItem("emp_code"),
    //     };

    //     if (validateForm()) {
    //         setLoading(true); //loading logic
    //         const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    //         try {
    //             let res = await axios.post(
    //                 // `${BASE_URL}/wfm/ourcompanyuserdetails-update-with-logs/${updatedformData.emp_code}/`,
    //                 `${BASE_URL}/wfm/ourcompanyuserdetaildirectaddwithLog/`,
    //                 // `${BASE_URL}/wfm/ourcompanyuserdetaildirectadd/`,
    //                 updatedformData,
    //             );
    //             if (res.status === 200) {
    //                 await getAllEmployee();
    //                 handleClose();
    //             } else {
    //                 alert(res);
    //             }
    //         } catch (err) {
    //             //toast Logic
    //             handleAllError(err, loadingToastId);
    //         } finally {
    //             setLoading(false); //loading logic
    //             toast.dismiss(loadingToastId);
    //         }
    //     }
    // };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const normalizedStatus = normalizeEmployeeStatus(formData.employee_status);
        const updatedformData = {
            ...formData,
            employee_status: normalizedStatus,
            updated_by: sessionStorage.getItem("emp_code"),
        };

        if (normalizedStatus === "active") {
            updatedformData.last_working_date = null; // Use "" if your backend prefers empty strings over null
        }

        if (normalizedStatus === "inactive" || updatedformData.prevcompany_last_working_date === "") {
            updatedformData.prevcompany_last_working_date = null;
        }

        if (updatedformData.last_working_date === "") {
            updatedformData.last_working_date = null;
        }

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    // `${BASE_URL}/wfm/ourcompanyuserdetails-update-with-logs/${updatedformData.emp_code}/`,
                    `${BASE_URL}/wfm/ourcompanyuserdetaildirectaddwithLog/`,
                    // `${BASE_URL}/wfm/ourcompanyuserdetaildirectadd/`,
                    updatedformData,
                );
                if (res.status === 200) {
                    await getAllEmployee();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleAllError(err, loadingToastId);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                className="employee-basic-details-edit"
                onClick={handleShow}
                title="Edit Company Details"
            >
                <UpdatePencil custompadding={"10px"} />
                {btn_title && <span className="ml-2"> {btn_title}</span>}
            </button>
            {buffer ? <div className="spinner-z"></div> : null}
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header className="flex-row justify-between">
                    <Modal.Title>
                        Edit Employee Details of "{formData.emp_code} : {formData.name}"
                    </Modal.Title>
                    {formData.sepration_form ? (
                        <ViewSeprationAndSettlementProcessStatus i={i} />
                    ) : (
                        <StartEmployeeSeprationProcess
                            empcode={i.emp_code}
                            empData={formData}
                            getEmployeeOrgData={getEmployeeOrgData}
                            databuffer={buffer}
                        />
                    )}
                </Modal.Header>
                <Modal.Body>
                    <>
                        <form className="register-form">
                            <div className="form-flex-wrap">
                                <div
                                    title="Email"
                                    style={{ cursor: "not-allowed" }}
                                    className="flex-column"
                                >
                                    <label
                                        htmlFor="user_detail"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Email <span className="required">(View-Only)</span>
                                    </label>
                                    <input
                                        type="user_detail"
                                        id="user_detail"
                                        name="user_detail"
                                        placeholder="Demo@gmail.com"
                                        readOnly
                                        style={{ cursor: "not-allowed" }}
                                        onChange={handleInputChange}
                                        value={formData.user_detail}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.toLowerCase().trim(); // Convert input to lowercase
                                        }}
                                        className={`form-input ${errors.user_detail
                                            ? "error"
                                            : inputState.user_detail
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.user_detail && (
                                        <span className="error-message font-size-text ">
                                            {errors.user_detail}
                                        </span>
                                    )}
                                </div>

                                <div
                                    title="Emp Code"
                                    style={{ cursor: "not-allowed" }}
                                    className="flex-column"
                                >
                                    <label
                                        htmlFor="emp_code"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Emp Code <span className="required">(View-Only)</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="emp_code"
                                        name="emp_code"
                                        placeholder="Emp Code"
                                        readOnly
                                        style={{ cursor: "not-allowed" }}
                                        onChange={handleInputChange}
                                        value={formData.emp_code}
                                        className={`form-input ${errors.emp_code
                                            ? "error"
                                            : inputState.emp_code
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emp_code && (
                                        <span className="error-message font-size-text ">
                                            {errors.emp_code}
                                        </span>
                                    )}
                                </div>

                                <div title="Machine Code" className="flex-column">
                                    <label
                                        htmlFor="machine_code"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Machine Code<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="machine_code"
                                        name="machine_code"
                                        placeholder="Machine Code"
                                        onChange={handleInputChange}
                                        value={formData.machine_code}
                                        className={`form-input ${errors.machine_code
                                            ? "error"
                                            : inputState.machine_code
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.machine_code && (
                                        <span className="error-message font-size-text ">
                                            {errors.machine_code}
                                        </span>
                                    )}
                                </div>

                                {SUPER_ADMIN && (
                                    <div title="Sub Company List" className="flex-column ">
                                        <label
                                            htmlFor="division"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Division<span className="required">*</span>
                                        </label>

                                        <select
                                            id="division"
                                            name="division"
                                            value={formData.division}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.division
                                                ? "error"
                                                : inputState.division
                                                    ? "success"
                                                    : ""
                                                }`}
                                        >
                                            <option value="">Select a Division</option>
                                            {SubCompany?.sort((a, b) =>
                                                a.title.localeCompare(b.title, "en", {
                                                    ignorePunctuation: true,
                                                }),
                                            ).map((i, index) => (
                                                <>
                                                    <option value={i.id}>{i.title}</option>
                                                </>
                                            ))}
                                        </select>

                                        <div>
                                            {errors.division && (
                                                <span className="error-message font-size-text ">
                                                    {errors.division}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div title="Departments List" className="flex-column ">
                                    <label
                                        htmlFor="department"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Department<span className="required">*</span>
                                    </label>

                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="department"
                                                name="department"
                                                value={formData.department}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.department
                                                    ? "error"
                                                    : inputState.department
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select Department</option>
                                                {departmentname
                                                    ?.sort((a, b) =>
                                                        a.title.localeCompare(b.title, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.id}>
                                                                {i.title}-{i.sub_company_name}
                                                            </option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.department && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.department}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="Designations List" className="flex-column ">
                                    <label
                                        htmlFor="designation"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Designation<span className="required">*</span>
                                    </label>

                                    {buffer2 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="designation"
                                                name="designation"
                                                value={formData.designation}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.designation
                                                    ? "error"
                                                    : inputState.designation
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select Designation</option>
                                                {designationname
                                                    ?.sort((a, b) =>
                                                        a.title.localeCompare(b.title, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.id}>
                                                                {i.title}-{i.sub_company_name}
                                                            </option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.designation && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.designation}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="Attendance Policy List" className="flex-column ">
                                    <label
                                        htmlFor="attendance_policy"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Attendance Policy<span className="required">*</span>
                                    </label>

                                    {buffer3 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="attendance_policy"
                                                name="attendance_policy"
                                                value={formData.attendance_policy}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.attendance_policy
                                                    ? "error"
                                                    : inputState.attendance_policy
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Attendance Policy</option>
                                                {attendpolicy
                                                    ?.sort((a, b) =>
                                                        a.name.localeCompare(b.name, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.id}>{i.name}</option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.attendance_policy && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.attendance_policy}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="WeeklyOff Policy List" className="flex-column ">
                                    <label
                                        htmlFor="weeklyoff_policy"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        WeeklyOff Policy<span className="required">*</span>
                                    </label>

                                    {buffer4 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="weeklyoff_policy"
                                                name="weeklyoff_policy"
                                                value={formData.weeklyoff_policy}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.weeklyoff_policy
                                                    ? "error"
                                                    : inputState.weeklyoff_policy
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Weeklyoff Policy</option>
                                                {weeklypolicy
                                                    ?.sort((a, b) =>
                                                        a.name.localeCompare(b.name, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.id}>{i.name}</option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.weeklyoff_policy && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.weeklyoff_policy}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="Work Location List" className="flex-column ">
                                    <label
                                        htmlFor="location"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Work Site<span className="required">*</span>
                                    </label>

                                    {buffer5 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="location"
                                                name="location"
                                                value={formData.location}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.location
                                                    ? "error"
                                                    : inputState.location
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a location</option>
                                                {worksite
                                                    ?.sort((a, b) =>
                                                        a.title.localeCompare(b.title, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.id}>{i.title}</option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.location && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.location}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="Reporting Heads List" className="flex-column ">
                                    <label
                                        htmlFor="reporting_head"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Reporting Head<span className="required">*</span>
                                    </label>

                                    {buffer6 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="reporting_head"
                                                name="reporting_head"
                                                value={formData.reporting_head}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.reporting_head
                                                    ? "error"
                                                    : inputState.reporting_head
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Reporting Head</option>
                                                {rhname
                                                    ?.sort((a, b) =>
                                                        a.name.localeCompare(b.name, "en", {
                                                            ignorePunctuation: true,
                                                        }),
                                                    )
                                                    .map((i, index) => (
                                                        <>
                                                            <option value={i.user_detail}>
                                                                {i.name}-{i.division_name}
                                                            </option>
                                                        </>
                                                    ))}
                                            </select>
                                            <div>
                                                {errors.reporting_head && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.reporting_head}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div title="Is Reporting Head" className="flex-column ">
                                    <label
                                        htmlFor="is_reporthead"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        Is Reporting Head<span className="required">*</span>
                                    </label>

                                    <select
                                        id="is_reporthead"
                                        name="is_reporthead"
                                        value={formData.is_reporthead?.toString() || ""}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.is_reporthead
                                            ? "error"
                                            : inputState.is_reporthead
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select Option</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>

                                    <div>
                                        {errors.is_reporthead && (
                                            <span className="error-message font-size-text ">
                                                {errors.is_reporthead}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div title="Dashboard Employee Roles" className="flex-column ">
                                    <label
                                        htmlFor="employee_type"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Employee Role<span className="required">*</span>
                                    </label>

                                    <select
                                        id="role"
                                        name="role"
                                        value={formData.role}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.role ? "error" : inputState.role ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select a Role</option>
                                        <option value="Employee">Employee</option>
                                        <option value="ReportingHead">Team Lead</option>
                                        <option value="HOD">HOD</option>
                                        <option value="Career">Career</option>
                                        <option value="HR">HR</option>
                                        <option value="Admin">Admin</option>
                                        <option value="IT">IT</option>
                                        <option value="Account">Accounts</option>
                                        <option value="SiteManagement">Site Management</option>
                                    </select>

                                    <div>
                                        {errors.role && (
                                            <span className="error-message font-size-text ">
                                                {errors.role}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div
                                    title="Employeee Cost-Center Assets"
                                    className="flex-column"
                                >
                                    <label
                                        htmlFor="cost_center_assets"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Cost Center Assets<span className="required">*</span>
                                    </label>

                                    <select
                                        id="cost_center_assets"
                                        name="cost_center_assets"
                                        value={formData.cost_center_assets}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.cost_center_assets
                                            ? "error"
                                            : inputState.cost_center_assets
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Cost Center Assets</option>
                                        <option value="employee">Employee</option>
                                        <option value="currentasset">Current Asset</option>
                                        <option value="fixedasset">Fixed Asset</option>
                                    </select>
                                    <div>
                                        {errors.cost_center_assets && (
                                            <span className="error-message font-size-text ">
                                                {errors.cost_center_assets}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div
                                    title="Employeee Default Letter Template"
                                    className="flex-column"
                                >
                                    <div className="flex-row">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Letter Templates
                                        </label>{" "}
                                        {formData.letter_template && (
                                            <div className="flex-row">
                                                <ViewLetterBuilder
                                                    buttonDisplay={"Eye-Name"}
                                                    buttonDisplayName="Preview"
                                                    templateID={formData?.letter_template}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    {buffer7 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="letter_template"
                                            name="letter_template"
                                            value={formData.letter_template}
                                            onChange={handleInputChange}
                                            className={`form-input`}
                                            required
                                        >
                                            <option value="">Select a Template</option>
                                            {lettersTemplate.map((i, index) => (
                                                <option key={index} value={i.id}>
                                                    {i.template_name}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                </div>

                                {/* <div title="Employeee Default Tax Regime" className="flex-column">
                                    <div className="flex-row">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Tax Regime
                                        </label>{" "}
                                      
                                    </div>
                                    {buffer7 ?
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div> :
                                        <select
                                            id="tax_regime"
                                            name="tax_regime"
                                            value={formData.tax_regime}
                                            onChange={handleInputChange}
                                            className={`form-input`}
                                            required
                                        >
                                            <option value="">Select a Regime</option>
                                            {taxRegimes.map((i, index) => (
                                                <option value={i?.id}>
                                                    {i?.name}({formatDate(i?.financial_year_start, true).MonthYear} - {formatDate(i?.financial_year_end, true).MonthYear})
                                                </option>
                                            ))}
                                        </select>}
                                    <div>
                                        {errors.cost_center_assets && (
                                            <span className="error-message font-size-text ">{errors.cost_center_assets}</span>
                                        )}
                                    </div>
                                </div> */}
                            </div>

                            <div className="jd-heading-outer heading-bg-color-white">
                                <div className="jd-heading-outer-flex">
                                    <h2 className="jd-heading-main font-weight600  font-size-heading">
                                        Employee Status{" "}
                                    </h2>
                                </div>
                                <div>
                                    <div className="jd-heading-bottom-bold"></div>
                                    <div className="jd-heading-bottom-light"></div>
                                </div>
                            </div>

                            <div className="form-flex-wrap">
                                <div title="Joining Date" className="flex-column">
                                    <label
                                        htmlFor="joining_date"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Joining Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="joining_date"
                                        name="joining_date"
                                        onChange={handleInputChange}
                                        value={formData.joining_date}
                                        className={`form-input ${errors.joining_date
                                            ? "error"
                                            : inputState.joining_date
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.joining_date && (
                                        <span className="error-message font-size-text ">
                                            {errors.joining_date}
                                        </span>
                                    )}
                                </div>

                                <div title="Employee Status" className="flex-column ">
                                    <label
                                        htmlFor="employee_status"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Employee Status<span className="required">*</span>
                                    </label>

                                    <select
                                        id="employee_status"
                                        name="employee_status"
                                        value={formData.employee_status}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.employee_status
                                            ? "error"
                                            : inputState.employee_type
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Status</option>
                                        <option value="active">Active</option>
                                        {/* <option value="action Required"</option> */}
                                        <option value="inactive">Inactive</option>
                                    </select>

                                    <div>
                                        {errors.employee_status && (
                                            <span className="error-message font-size-text ">
                                                {errors.employee_status}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div title="Employee Type" className="flex-column ">
                                    <label
                                        htmlFor="employee_type"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Employee Type<span className="required">*</span>
                                    </label>

                                    <select
                                        id="employee_type"
                                        name="employee_type"
                                        value={formData.employee_type}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.employee_type
                                            ? "error"
                                            : inputState.employee_type
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Employee</option>
                                        <option value="permanent">Permanent</option>
                                        <option value="temporary">Temporary</option>
                                        <option value="probation">Probation</option>
                                        <option value="termination">Termination</option>
                                        <option value="resigned">Resigned</option>
                                        <option value="absconding">Absconding</option>
                                        <option value="healthissue">Health Issue</option>
                                        <option value="intern">Intern</option>
                                        <option value="trainee">Trainee</option>
                                        <option value="transferred">Transferred</option>
                                    </select>

                                    <div>
                                        {errors.employee_type && (
                                            <span className="error-message font-size-text ">
                                                {errors.employee_type}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* <div title="Last Working Date" className="flex-column">
                                    <label
                                        htmlFor="last_working_date"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        Last Working Date
                                        {formData.employee_status === "inactive" ||
                                            (initialStatus === "inactive" &&
                                                formData.employee_status === "active") ? (
                                            <span className="required">*</span>
                                        ) : null}
                                    </label>
                                    <input
                                        type="date"
                                        id="last_working_date"
                                        name="last_working_date"
                                        onChange={handleInputChange}
                                        value={formData.last_working_date}
                                        className={`form-input ${errors.last_working_date
                                            ? "error"
                                            : inputState.last_working_date
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.last_working_date && (
                                        <span className="error-message font-size-text ">
                                            {errors.last_working_date}
                                        </span>
                                    )}
                                </div> */}

                                {/* Standard Last Working Date - Shown when making employee Inactive */}
                                {!isChangingToActive && (
                                    <div title="Last Working Date" className="flex-column">
                                        <label htmlFor="last_working_date" className="form-labels font-weight500 font-size-subheading">
                                            Last Working Date
                                            {formData.employee_status === "inactive" ? <span className="required">*</span> : null}
                                        </label>
                                        <input
                                            type="date"
                                            id="last_working_date"
                                            name="last_working_date"
                                            onChange={handleInputChange}
                                            value={formData.last_working_date || ""}
                                            className={`form-input ${errors.last_working_date ? "error" : inputState.last_working_date ? "success" : ""}`}
                                        />
                                        {errors.last_working_date && (
                                            <span className="error-message font-size-text ">{errors.last_working_date}</span>
                                        )}
                                    </div>
                                )}

                                {/* Previous Company Last Working Date - Shown ONLY when transitioning Inactive -> Active */}
                                {isChangingToActive && (
                                    <div title="Previous Company Last Working Date" className="flex-column">
                                        <label htmlFor="prevcompany_last_working_date" className="form-labels font-weight500 font-size-subheading">
                                            Prev Company Last Working Date<span className="required">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            id="prevcompany_last_working_date"
                                            name="prevcompany_last_working_date"
                                            onChange={handleInputChange}
                                            value={formData.prevcompany_last_working_date || ""}
                                            className={`form-input ${errors.prevcompany_last_working_date ? "error" : inputState.prevcompany_last_working_date ? "success" : ""}`}
                                        />
                                        {errors.prevcompany_last_working_date && (
                                            <span className="error-message font-size-text ">{errors.prevcompany_last_working_date}</span>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="jd-heading-outer heading-bg-color-white">
                                <div className="jd-heading-outer-flex">
                                    <h2 className="jd-heading-main font-weight600  font-size-heading">
                                        Leave Balance{" "}
                                    </h2>
                                </div>
                                <div>
                                    <div className="jd-heading-bottom-bold"></div>
                                    <div className="jd-heading-bottom-light"></div>
                                </div>
                            </div>
                            <div className="form-flex-wrap">
                                <div title="Previous Leave Balance" className="flex-column">
                                    <label
                                        htmlFor="leavebalance"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        Previous Leave Balance<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="leavebalance"
                                        name="leavebalance"
                                        placeholder="Leave Balance"
                                        onChange={handleInputChange}
                                        value={formData.leavebalance}
                                        className={`form-input ${errors.leavebalance
                                            ? "error"
                                            : inputState.leavebalance
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.leavebalance && (
                                        <span className="error-message font-size-text ">
                                            {errors.leavebalance}
                                        </span>
                                    )}
                                </div>

                                <div title="Casual Leave Balance" className="flex-column">
                                    <label
                                        htmlFor="casual_leave"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        Casual Leave Balance<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="casual_leave"
                                        name="casual_leave"
                                        placeholder="Casual Leave Balance"
                                        onChange={handleInputChange}
                                        value={formData.casual_leave}
                                        className={`form-input ${errors.casual_leave
                                            ? "error"
                                            : inputState.casual_leave
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.casual_leave && (
                                        <span className="error-message font-size-text ">
                                            {errors.casual_leave}
                                        </span>
                                    )}
                                </div>

                                <div title="Sick Leave Balance" className="flex-column">
                                    <label
                                        htmlFor="sick_leave"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        Sick Leave Balance<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="sick_leave"
                                        name="sick_leave"
                                        placeholder="Sick Leave Balance"
                                        onChange={handleInputChange}
                                        value={formData.sick_leave}
                                        className={`form-input ${errors.sick_leave
                                            ? "error"
                                            : inputState.sick_leave
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.sick_leave && (
                                        <span className="error-message font-size-text ">
                                            {errors.sick_leave}
                                        </span>
                                    )}
                                </div>

                                <div title="Earn Leave Balance" className="flex-column">
                                    <label
                                        htmlFor="Earn Leave"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        Earn Leave Balance{" "}
                                        <span className="required">(View-Only)</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="earn_leave"
                                        name="earn_leave"
                                        readOnly
                                        placeholder="Earn Leave Balance"
                                        onChange={handleInputChange}
                                        value={formData.earn_leave}
                                        className={`form-input ${errors.earn_leave
                                            ? "error"
                                            : inputState.earn_leave
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.earn_leave && (
                                        <span className="error-message font-size-text ">
                                            {errors.earn_leave}
                                        </span>
                                    )}
                                </div>

                                <div title="Short Leave Balance" className="flex-column">
                                    <label
                                        htmlFor="Short Leave"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        Short Leave Balance{" "}
                                        <span className="required">(View-Only)</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="short_leave"
                                        name="short_leave"
                                        readOnly
                                        placeholder="Short Leave Balance"
                                        onChange={handleInputChange}
                                        value={formData.short_leave}
                                        className={`form-input ${errors.short_leave
                                            ? "error"
                                            : inputState.short_leave
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.short_leave && (
                                        <span className="error-message font-size-text ">
                                            {errors.short_leave}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="jd-heading-outer heading-bg-color-white">
                                <div className="jd-heading-outer-flex">
                                    <h2 className="jd-heading-main font-weight600  font-size-heading">
                                        Visibility{" "}
                                    </h2>
                                </div>
                                <div>
                                    <div className="jd-heading-bottom-bold"></div>
                                    <div className="jd-heading-bottom-light"></div>
                                </div>
                            </div>

                            <div className="flex-row justify-evenly">
                                <div className="flex-row ">
                                    <div className="checkbox-toggle">
                                        <input
                                            type="checkbox"
                                            id="toggle_show_herarchy"
                                            name="show_herarchy"
                                            checked={formData.show_herarchy}
                                            onChange={handleCheckboxChange}
                                        />
                                        <label htmlFor="toggle_show_herarchy"></label>
                                    </div>
                                    <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
                                    <label
                                        htmlFor=""
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        {formData.show_herarchy ? "View" : "Hide"} in Hierarchy{" "}
                                    </label>
                                </div>

                                <div className="flex-row ">
                                    <div className="checkbox-toggle">
                                        <input
                                            type="checkbox"
                                            id="toggle_show_attendance"
                                            name="show_attendance"
                                            checked={formData.show_attendance}
                                            onChange={handleCheckboxChange}
                                        />
                                        <label htmlFor="toggle_show_attendance"></label>
                                    </div>
                                    <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
                                    <label
                                        htmlFor="EmpCode"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        {formData.show_attendance ? "View" : "Hide"} Attendance{" "}
                                    </label>
                                </div>

                                <div className="flex-row ">
                                    <div className="checkbox-toggle">
                                        <input
                                            type="checkbox"
                                            id="toggle_advance_form"
                                            name="advance_form"
                                            checked={formData.advance_form}
                                            onChange={handleCheckboxChange}
                                        />
                                        <label htmlFor="toggle_advance_form"></label>
                                    </div>
                                    <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
                                    <label
                                        htmlFor=""
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        {formData.advance_form ? "View" : "Hide"} Advance Form{" "}
                                    </label>
                                </div>

                                {/* <div title="Separation Format" className="flex-column ">
                                    <div className="flex-row ">
                                        <label htmlFor="" className="form-labels  font-weight500    font-size-subheading">
                                            {formData.sepration_form ? "View" : "Hide"} Separation Form {" "}
                                        </label>
                                        <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id="sepration_form"
                                                name="sepration_form"
                                                checked={formData.sepration_form}
                                                onChange={handleCheckboxChange}
                                            />
                                            <label htmlFor="sepration_form"></label>
                                        </div>
                                    </div>
                                    {formData.sepration_form ?
                                        <div>
                                            <select
                                                id="sepration_format"
                                                name="sepration_format"
                                                value={formData.sepration_format}
                                                onChange={handleInputChange}
                                                className={`form-input  ${errors.sepration_format ? "error" : inputState.sepration_format ? "success" : ""
                                                    }`}
                                            >
                                                <option value="">Select Separation Format</option>

                                            </select>
                                            <DropdownArrow />
                                            <div>
                                                {errors.sepration_format && (
                                                    <span className="error-message font-size-text ">{errors.sepration_format}</span>
                                                )}
                                            </div></div>
                                        : null}
                                </div> */}

                                {/* {
                                    formData.sepration_form
                                        ?
                                        <ViewSeprationAndSettlementProcessStatus i={i} />
                                        :
                                        <StartEmployeeSeprationProcess empcode={i.emp_code} empData={formData} getEmployeeOrgData={getEmployeeOrgData} databuffer={buffer} />
                                } */}
                            </div>

                            {divisionChangeNoticeError && (
                                <div className="flex-column" style={{ marginTop: "5px" }}>
                                    <div style={{ color: "red" }}>
                                        {divisionChangeNoticeError}
                                    </div>
                                    <label
                                        className="form-labels  font-weight500    font-size-subheading"
                                        style={{ marginTop: "5px" }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={DivisionChangeConfirmation}
                                            onChange={(e) =>
                                                setDivisionChangeConfirmation(e.target.checked)
                                            }
                                        />
                                        <> </>
                                        <span>
                                            Confirm to proceed with Division/Sub-Company change.
                                        </span>
                                        <span>
                                            (Note: Close the modal without submitting to discard
                                            changes.)
                                        </span>
                                    </label>
                                </div>
                            )}

                            <div className="button-models">
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleClose();
                                    }}
                                    className="model-button model-button-cancel font-weight500"
                                    disabled={loading}
                                >
                                    {/* //loading logic */}
                                    Close
                                </button>
                                <button
                                    onClick={handleFormSubmit}
                                    className="model-button font-weight500 model-button-submit"
                                    disabled={loading}
                                >
                                    {/* //loading logic */}
                                    Submit
                                </button>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted &&
                                    Object.keys(errors).length > 0 &&
                                    (Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">
                                            Please fill all mandatory fields!
                                        </h5>
                                    ) : (
                                        <h6 className="text-center">
                                            {Object.keys(errors)
                                                .map((field) =>
                                                    field
                                                        .replace(/_/g, " ")
                                                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                                                )
                                                .join(", ") + " are required!"}
                                        </h6>
                                    ))}
                            </p>
                        </form>
                    </>
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

// export default AddNewEmployeeData;
export { AddNewEmployeeData, UpdateEmployeeData, confirmToast };
